import { render, staticRenderFns } from "./IntegralPrize.vue?vue&type=template&id=0bc1939c&scoped=true&"
import script from "./IntegralPrize.vue?vue&type=script&lang=js&"
export * from "./IntegralPrize.vue?vue&type=script&lang=js&"
import style0 from "./IntegralPrize.vue?vue&type=style&index=0&id=0bc1939c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc1939c",
  null
  
)

export default component.exports